jQuery(document).ready(function () {
	jQuery('.filter-of-blog a').click(function () {
		jQuery(this).siblings().removeClass('active');
		jQuery(this).addClass('active');
		jQuery('.articles-1').addClass('loading');
		jQuery('.articles-2').addClass('loading');
		var tag = jQuery(this).attr('data-tag');
		if(tag == 'all'){
			var new_url_1 = '/blogs/news';
		}else{
			var new_url_1 = '/blogs/news/tagged/'+tag;
		}
		jQuery.ajax(
            {
                url:new_url_1,
                type:'GET',
                dataType:'html'
            }
        ).done(function(new_page){
			
            var new_articles = jQuery(new_page).find('.feature-blogs__items').html();
			if(new_articles){
				jQuery('.link-1').attr('href',new_url_1);
				jQuery('.articles-1').html(new_articles);
			}else{
				jQuery('.link-1').attr('href','/blogs/news/');
				jQuery('.articles-1').html('<p>Sorry, there are no matching coffee Knowledge. Please try a different filter.</p>');
			}
			jQuery('.articles-1').removeClass('loading');
        });
		
		/* jQuery.ajax(
            {
                url:new_url_2,
                type:'GET',
                dataType:'html'
            }
        ).done(function(new_page){
			
            var new_articles = jQuery(new_page).find('.feature-blogs__items').html();
			if(new_articles){
				jQuery('.link-2').attr('href',new_url_2);
				jQuery('.articles-2').html(new_articles);
			}else{
				jQuery('.link-2').attr('href','/blogs/featured-roasters/');
				jQuery('.articles-2').html('<p>Sorry, there are no matching featured roasters. Please try a different filter.</p>');
			}
			jQuery('.articles-2').removeClass('loading');
        }); */
		
	});
});